export function show_modal_insert_users_tag(state = false, action) {
  if (action.type === 'SHOW_MODAL_INSERT_TAG') {
    return true;
  }
  if (action.type === 'HIDE_MODAL_INSERT_TAG') {
    return false;
  }
  return state;
}
